import 'animate.css/animate.min.css';
import '@/assets/css/scroll-animate.less';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, useRoutes, useSearchParams } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import route from './route';
import NavBar from '@/components/NavBar';
import BottomPage from '@/components/BottomPage';
import './App.css';
import '@/assets/css/typography.less';
import CookieConsent from '@/components/CookieConsent';
import ScrollToTop from '@/components/ScrollToTop';
import useScrollReveal from '@/hooks/useScrollReveal';

const anchorScroll = (id) => {
  const anchorElement = document.getElementById(id);
  if (anchorElement) {
    anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
};

const RouteRender = () => {
  const routes = useRoutes(route);
  const [params] = useSearchParams();
  const id = params.get('id') || '';

  useScrollReveal();

  useEffect(() => {
    if (id) {
      const timer = setTimeout(() => anchorScroll(id), 10);
      return () => clearTimeout(timer);
    }
  }, [id]);

  return routes;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <NavBar />
        <div className="app_warp">
          <Suspense fallback={<div className="loading">Loading...</div>}>
            <RouteRender />
          </Suspense>
        </div>
        <BottomPage />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
